<template>
    <div class="banner" v-if="bannerList && bannerList.length > 0">
        <van-swipe class="swipe-banner" :autoplay="3000" style="height: 106px;" indicator-color="white" @change="onChangeBanner">
            <van-swipe-item v-for="(image, index) in bannerList" :key="index" class="swipe-item" style="height: 82px; overflow: hidden;" @click="bannerJump(image, 2)">
                <img :src="image.imag" class="banner-img"/>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import { Swipe, SwipeItem, Toast, Icon } from 'vant';
import { toPage, randomString } from "@/utils/tools";

export default {
    name: 'banner',
    props: {
        bannerList: {
            type: Array,
            default: () => []
        }
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Icon.name]: Icon,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        onChangeBanner(index) {
            // console.log('banner1231235435', index)
            this.$emit('setTrack', {
                action: 'students_banner_show',
                label: 'Banner曝光',
                value: {"channel":"学生专区","scene":"公共","bannerlink": this.bannerList[index].url}
            })
        },
        bannerJump(info, type) {
            this.$emit('setTrack', {
                action: 'students_banner_click',
                label: 'Banner点击',
                value: {"channel":"学生专区","scene":"公共","bannerlink": info.url}
            })
            toPage(info.url)
        },
    }
}
</script>

<style lang="less" scoped>
.banner {
    position: relative;
    margin: 12px;
    .swipe-banner {
        border-radius: 8px;
        .swipe-item {
            border-radius: 8px;
            .banner-img {
                width: 100%;
                height: 82px;
                object-fit: cover;
            }
        }
    }
    
}
</style>>
